import mixpanel from 'mixpanel-browser';
mixpanel.init('945f6022f4e5e9a952cc9b31dc34625d');

const env_check = process.env.NODE_ENV === 'production';

const actions = {
  identify: (id: string) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name: string, props?: Record<string, any>) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props: Record<string, any>) => {
      if (env_check) mixpanel.people.set(props);
    }
  }
};

export const Mixpanel = actions;
